<div class="sticky sticky-crm pl-0 overflow-x-auto si-table-container" [formGroup]="form">
    <div *ngIf="technoExportMappingSetting" class="technographics-content">
        <table class="si-table" [formArrayName]="mappingType">
            <thead>
                <tr>
                    <th width="50%" scope="col" class="border-t-0 uppercase text-primary">SalesIntel TECHNOLOGY</th>
                    <th width="50%" scope="col" class="border-t-0 uppercase text-primary">{{exportType}} FIELD</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let salesintelTechnology of form.get(mappingType).controls; let i = index;"
                    [formGroupName]="i">
                    <td class="capitalize align-middle" scope="row">
                        {{ exportMappings[i]?.salesintelTechnology }}
                    </td>
                    <td>
                        <mat-form-field appearance="outline" class="mb-2 w-full no-padding"
                        [class.mat-form-field-invalid]="salesintelTechnology.value.isError || salesintelTechnology.value.isBug || salesintelTechnology.get(exportControlName).hasError(duplicateFieldError)">
                            <mat-label>{{ exportMappings[i]?.salesintelTechnology }}</mat-label>
                            <mat-select
                                [ngClass]="{ 'mat-form-field-invalid': salesintelTechnology.value.isError || salesintelTechnology.value.isBug || salesintelTechnology.get(exportControlName).hasError(duplicateFieldError) }"
                                [formControlName]="exportControlName"
                                (selectionChange)="isValid(salesintelTechnology.value.salesintelTechnology)" #siSelectRef="matSelect"
                                [tooltipIfTruncated]="siSelectRef.triggerValue" targetSelector=".mat-mdc-select-value">
                                <mat-option [value]="exportMappings[i]?.[exportControlName]" *ngIf="salesintelTechnology.value.isBug"></mat-option>
                                <mat-option [value]="(null || undefined || '') ? '' : ''">-- skip --</mat-option>
                                <mat-option [value]="field.field" *ngFor="let field of exportFieldArray | filterlist: exportMappings[i]?.type " [tooltipIfTruncated]="field.label" targetSelector=".mdc-list-item__primary-text">
                                    {{ field.label }}
                                </mat-option>
                            </mat-select>
                            <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                        </mat-form-field>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="technographics-content" *ngIf="!technoExportMappingSetting">
        <div class="sticky sticky-crm pl-0 text-center pt-12 si-table-container">
            Select your target technologies to export to {{exportType}}.
            <br />
            <div class="flex flex-wrap -mx-2 pt-4 mb-12">
                <div class="w-full sm:flex-none sm:w-full text-center px-2">
                    <button
                        matButton="outlined"
                        type="button"
                        [routerLink]="['/', { outlets: { modal: [modalNavigationEnum.TECHNOGRAPHICS] } }]"
                    > Let's Go </button>
                </div>
            </div>
        </div>
    </div>
</div>
